import React, { useState } from 'react';

const JobInputForm = ({ onSubmit, onClear, isLoading }) => {
  const [jobText, setJobText] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (jobText.trim()) {
      onSubmit(jobText.trim());
    }
  };

  const handleClear = () => {
    setJobText('');
    onClear();
  };

  return (
    <div className="job-input-form">
      <h2>Job Posting Input</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="job-posting">
            Paste the job posting text below to customize your resume:
          </label>
          <textarea
            id="job-posting"
            className="job-textarea"
            value={jobText}
            onChange={(e) => setJobText(e.target.value)}
            placeholder="Paste the complete job posting here...

Example:
Software Engineer - ABC Company
Location: San Francisco, CA

Job Description:
We are looking for a talented Software Engineer to join our team...

Requirements:
- Bachelor's degree in Computer Science
- 3+ years of experience with JavaScript
- Knowledge of React, Node.js
- Experience with databases"
            disabled={isLoading}
          />
        </div>
        
        <div className="button-group">
          <button 
            type="submit" 
            className="btn btn-primary"
            disabled={!jobText.trim() || isLoading}
          >
            {isLoading ? 'Processing...' : 'Generate Resume'}
          </button>
          
          <button 
            type="button" 
            className="btn btn-secondary"
            onClick={handleClear}
            disabled={isLoading}
          >
            Clear
          </button>
        </div>
      </form>
    </div>
  );
};

export default JobInputForm;